import { defineComponent } from 'vue';

export default defineComponent({
    name: "Error",
    props: {
        error: {
            type: String,
            required: true
        }
    },
    setup: function (props, ctx) {
        return {

        }
    }
});